import {
    IListIndexadoresSienge,
    IListPortadoresSienge,
    IListTipoCondicoesPagamentoSienge,
    IRealizarRenegociacaoSienge,
} from "../../../Interfaces/Cobranca/RenegociacaoSienge/RenegociacaoSiengeInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarTiposCondicaoPagamentoSiengeService(
    pesquisa: string
) {
    return Service(
        Axios.get<Array<IListTipoCondicoesPagamentoSienge>>(
            `/cobranca/renegociacao/listartiposcondicaopagamento?pesquisa=${pesquisa}`
        )
    );
}

export async function ListarPortadoresSiengeService() {
    return Service(
        Axios.get<Array<IListPortadoresSienge>>(
            `/cobranca/renegociacao/listarportadores`
        )
    );
}

export async function ListarIndexadoresSiengeService() {
    return Service(
        Axios.get<Array<IListIndexadoresSienge>>(
            `/cobranca/renegociacao/listarindexadores`
        )
    );
}

export async function RealizarRenegociacaoSiengeService(
    idCaso: number,
    requestBody: IRealizarRenegociacaoSienge
) {
    return Service(
        Axios.post(
            `/cobranca/renegociacao/realizarrenegociacao?idCaso=${idCaso}`,
            requestBody
        )
    );
}
